import { render, staticRenderFns } from "./ProblemModal.vue?vue&type=template&id=ecc3765a&scoped=true"
import script from "./ProblemModal.vue?vue&type=script&lang=js"
export * from "./ProblemModal.vue?vue&type=script&lang=js"
import style0 from "./ProblemModal.vue?vue&type=style&index=0&id=ecc3765a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc3765a",
  null
  
)

export default component.exports